"use client";

import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import { Button } from "@/components/ui/button";

import { Plus } from "lucide-react";

import type { StepId } from "@/features/multistep/registry/types";

import { useLocations } from "@/hooks/use-location";
import { AccionistaForm } from "./accionista/accionista-form";

export function AccionistasStep({ stepId }: { stepId: StepId }) {
  const { control, trigger } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `${stepId}.accionistas`,
  });

  const { paises } = useLocations();

  // 👀 Aquí observamos todos los accionistas de una sola vez
  const accionistas =
    useWatch({ control, name: `${stepId}.accionistas` }) || [];

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Accionistas</h2>

      {fields.map((field, index) => {
        const accionista = accionistas[index] || {};

        return (
          <AccionistaForm
            key={field.id}
            index={index}
            stepId={stepId}
            accionista={accionista}
            remove={remove}
            paises={paises}
          />
        );
      })}

      {/* Botón agregar */}
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          append({
            tipoDocumento: "",
            numeroDocumento: "",
            nombre: "",
            telefono: "",
            pais: "",
            departamento: "",
            ciudad: "",
            porcentaje: "",
          });

          trigger(`${stepId}.${fields.length}`);
        }}
      >
        <Plus className="h-4 w-4 mr-2" />
        Agregar accionista
      </Button>
    </div>
  );
}
